
import './pl_landlord.css';
import StaffMockHost from './staff-mock-host.vue';

var COL_DEFS = [
  { lines: ['収入額'], field: 'income', width: 80 },
  { lines: ['宿泊税'], field: 'stay_tax', width: 80 },
  { lines: ['A総売上'], field: 'A', width: 80 },
  { lines: ['Bサイト手数料', '（A〇％）'], field: 'B', width: 96 },
  { lines: ['C弊社報酬', '（A〇％）'], field: 'C', width: 80 },
  { lines: ['D清掃費'], field: 'D', width: 80 },
  { lines: ['Eアメニティ'], field: 'E', width: 80 },
  { lines: ['F消耗品', '○○円*人数*日数'], field: 'F', width: 104 },
  { lines: ['Gクリーニング', '○○円*人数'], field: 'G', width: 104 },
  { lines: ['Hウエルカム', 'シャンパン'], field: 'H', width: 104 }
];

export default {
  name: 'pl-landlord-overview',
  components: {
    StaffMockHost: StaffMockHost
  },
  data: function () {
    var now = new Date();
    return {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      keyword: '',
      columns: COL_DEFS,
      rooms: [],
      totals: {}
    };
  },
  computed: {
    visibleRooms: function () {
      var kw = (this.keyword || '').trim();
      if (!kw) return this.rooms;
      return (this.rooms || []).filter(function (room) {
        return String(room.room_name || '').indexOf(kw) !== -1;
      });
    },
    yearOptions: function () {
      var now = new Date().getFullYear();
      var start = Math.min(now - 2, 2025);
      var end = Math.max(now + 2, 2026);
      var years = [];
      for (var y = start; y <= end; y++) years.push(y);
      return years;
    }
  },
  watch: {
    year: function () {
      this.loadOverview();
    },
    month: function () {
      this.loadOverview();
    }
  },
  created: function () {
    this.loadOverview();
  },
  methods: {
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    toastFail: function (status) {
      if (status == -5) this.toast('未ログイン');
      else if (status == -6) this.toast('権限がありません');
      else this.toast('取得に失敗しました');
    },
    shiftYear: function (delta) {
      var next = Number(this.year) + delta;
      if (next < 2000 || next > 2100) return;
      this.year = next;
    },
    shiftMonth: function (delta) {
      var m = Number(this.month) + delta;
      var y = Number(this.year);
      if (m < 1) {
        m = 12;
        y -= 1;
      } else if (m > 12) {
        m = 1;
        y += 1;
      }
      this.year = y;
      this.month = m;
    },
    printPdf: function () {
      window.print();
    },
    cellText: function (room, field) {
      if (!room || room[field] == null || room[field] === '') return '';
      return this.formatNum(room[field]);
    },
    totalCell: function (field) {
      var totals = this.totals || {};
      if (totals[field] == null || totals[field] === '') return '';
      return this.formatNum(totals[field]);
    },
    formatNum: function (n) {
      if (n == null || n === '') return '';
      var num = Number(n);
      if (!isFinite(num)) return n;
      return String(Math.round(num)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    applyOverview: function (opt) {
      opt = opt || {};
      this.rooms = opt.rooms || [];
      this.totals = opt.totals || {};
    },
    loadOverview: function () {
      var t = this;
      axios.get('settlement/companyOverview', {
        params: { year: t.year, month: t.month }
      }).then(function (res) {
        if (res.data.status != 1) {
          t.toastFail(res.data.status);
          t.rooms = [];
          t.totals = {};
          return;
        }
        t.applyOverview(res.data.options || {});
      }).catch(function () {
        t.toast('通信に失敗しました');
        t.rooms = [];
        t.totals = {};
      });
    }
  }
};
